<template>
  <div class="home">
    <SiteNav />
  </div>
</template>

<script>
// @ is an alias to /src
import SiteNav from "@/components/SiteNav.vue";

export default {
  name: "Home",
  components: {
    SiteNav,
  },
};
</script>

<style scoped lang="less">
.home {
  height: 100%;
}
</style>
